/**
@format
@flow
*/

import React from 'react';
import ListItemWrapper from './ListItemWrapper';
import type { Props as ListItemWrapperProps } from './ListItemWrapper';
import ListItemSquircle from './ListItemSquircle';
import type { Props as ListItemSquircleProps } from './ListItemSquircle';
import ListItemIcon from './ListItemIcon';
import type { Props as ListItemIconProps } from './ListItemIcon';

export type DefaultType = {|variant?: 'default', ...ListItemWrapperProps|};
export type SquircleType = {|variant?: 'squircle', ...ListItemSquircleProps|};
export type IconType = {|variant?: 'icon', ...ListItemIconProps|};

export type ListItemType = DefaultType | SquircleType | IconType;

const ListItem: React$ComponentType<ListItemType> = (props: Object): React$Node => {
  const {
    variant,
    ...rest
  } = props;

  switch (variant) {
  case 'squircle':
    return <ListItemSquircle {...rest} />;
  case 'icon':
    return <ListItemIcon {...rest} />;
  case 'default':
  default:
    return <ListItemWrapper {...rest} />;
  }
};

export default ListItem;
